export const ageFromBirth = (birth) => {
  if (!birth) return null;
  const b = new Date(birth + "T00:00:00");
  if (isNaN(b)) return null;
  const t = new Date();
  let age = t.getFullYear() - b.getFullYear();
  const m = t.getMonth() - b.getMonth();
  if (m < 0 || (m === 0 && t.getDate() < b.getDate())) age--;
  return age;
};

const n = (v) => (v === "" || v === null || v === undefined || isNaN(parseFloat(v)) ? null : parseFloat(v));

export const calcImc = (weight, heightCm) => {
  const w = n(weight), h = n(heightCm);
  if (!w || !h) return null;
  return Math.round((w / Math.pow(h / 100, 2)) * 10) / 10;
};

export const colorImc = (v) => {
  if (v === null || v === undefined) return null;
  if (v < 18.5 || v >= 30) return "red";
  if (v >= 25) return "yellow";
  return "green";
};

export const fatMax = (sex, age) => {
  if (age === null) return null;
  if (sex === "Feminino") return age <= 39 ? 32 : age <= 59 ? 33 : 35;
  if (sex === "Masculino") return age <= 39 ? 19 : age <= 59 ? 21 : 24;
  return null;
};

export const colorFat = (v, sex, age) => {
  v = n(v); const m = fatMax(sex, age);
  if (v === null || m === null) return null;
  return v > m ? "red" : "green";
};

export const muscleMin = (sex, age) => {
  if (age === null) return null;
  if (sex === "Masculino") return age <= 35 ? 34 : age <= 55 ? 30 : 27;
  if (sex === "Feminino") return age <= 35 ? 26 : age <= 55 ? 24 : 22;
  return null;
};

export const colorMuscle = (v, sex, age) => {
  v = n(v); const mn = muscleMin(sex, age);
  if (v === null || mn === null) return null;
  return v >= mn ? "green" : "red";
};

export const colorVisceral = (v) => {
  v = n(v);
  if (v === null) return null;
  return v <= 9 ? "green" : "red";
};

export const colorBodyAge = (v, age) => {
  v = n(v);
  if (v === null || age === null) return null;
  return v <= age ? "green" : "red";
};

export const colorClasses = {
  green: "bg-emerald-500/15 text-emerald-400 border-emerald-500/40",
  yellow: "bg-amber-500/15 text-amber-400 border-amber-500/40",
  red: "bg-red-500/15 text-red-400 border-red-500/40",
};

export const colorLabel = { green: "Bom", yellow: "Atenção", red: "Atenção" };
